export enum MODAL_SIZES {
  SMALL = 617,
  MEDIUM = 670,
  LARGE = 852,
}
